import { useState, useCallback } from "react";
import { useAuth } from "src/contexts/auth-provider";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { GET_TAGS } from "src/constants/queries";
import { failureToast } from "src/utils/toasts";
import { MenuTag } from "src/interfaces/menu.interface";

export const useMenuTags = () => {
  const { axBe } = useAxiosInterceptor();
  const { hasRestaurant } = useAuth();
  const [menuTags, setMenuTags] = useState<MenuTag[]>([]);
  const [isMenuTagsLoading, setIsMenuTagsLoading] = useState(false);

  const fetchMenuTags = useCallback(async () => {
    if (!hasRestaurant?.correlationId) return;

    setIsMenuTagsLoading(true);

    try {
      const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
        query: GET_TAGS,
        variables: {
          storeCorrelationId: hasRestaurant.correlationId,
        },
      });

      if (data?.data?.tags) {
        setMenuTags(data.data.tags);
      }
    } catch (err) {
      console.error("Error fetching tags:", err);
      failureToast("Failed to fetch tags")
    } finally {
      setIsMenuTagsLoading(false);
    }
  }, [axBe, hasRestaurant?.correlationId]);

  return {
    menuTags,
    isMenuTagsLoading,
    fetchMenuTags,
  };
};

